import * as React from 'react';
import { IAppContext } from './app-context.types';
import { useContext } from 'react';

const AppContext = React.createContext<IAppContext>({} as IAppContext);
const useAppContext = (): IAppContext => useContext<IAppContext>(AppContext);

export { AppContext, useAppContext };
